// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__unlyW","result":"style_result__jOQP8","header":"style_header___4UhD","button":"style_button__1DdPE","test":"style_test__3pbrK"};